import React from 'react';

export default function LegacyContentWorkspaceChoices({ choices, targets, loading, error, onChange }) {
    return <div style={{ marginTop: 16 }}>
        {loading && <p>Loading workspace choices and legacy content counts…</p>}
        {error && <p role="alert">Could not load workspace choices: {error}. Close and reopen this dialog to retry.</p>}
        {choices.length > 0 && <>
            <p>Choose where each owner’s unassigned legacy content belongs. Content already assigned to a workspace stays there. These choices do not change storefront addresses, plans, or credits.</p>
            {choices.map(choice => <div key={choice.owner} style={{ marginBottom: 16 }}>
                <label style={{ display: 'block' }}>
                    Legacy content workspace for {choice.workspaces[0]?.name || choice.owner}
                    <select style={{ display: 'block', width: '100%', marginTop: 6, padding: 8 }}
                        disabled={loading || Boolean(error)}
                        value={targets[choice.owner] || ''}
                        onChange={event => onChange(choice.owner, event.target.value)}>
                        <option value="">Select a workspace…</option>
                        {choice.workspaces.map(workspace => <option key={workspace.tenantId} value={workspace.tenantId}>
                            {workspace.domain || workspace.customDomain || 'No storefront address'} — {workspace.tenantId}
                        </option>)}
                    </select>
                </label>
                <p style={{ fontSize: 13 }}>Unassigned content: {Object.entries(choice.unstampedCollections || {}).map(([collection, count]) => `${collection}: ${count}`).join(', ') || 'None'}</p>
            </div>)}
        </>}
    </div>;
}
